import { render, staticRenderFns } from "./FormDataView.vue?vue&type=template&id=652ad66f&"
import script from "./FormDataView.vue?vue&type=script&lang=js&"
export * from "./FormDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports